module.exports = __webpack_public_path__ + "static/4-535d5fa7850e4a10127041537da173ad.jpg";